export default __webpack_public_path__ + "static/laptop-ad5da69a025c79946f60cd18bcc0785a.png";